import 'lazysizes'
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks'

import $ from 'jquery'
import initGreenSock  from '/lib/greensock'
import initHeadroom   from '/lib/headroom'
import initMobileNav  from '/lib/mobile-nav'
import initCookies    from '/lib/cookies'
import initScrollTo   from '/lib/scroll-to'
import initSlick      from '/lib/sliders'
import initMagnificPopup from '/lib/magnificPopup'
import initLibrary from './lib/library'
import initTeamAccordions from './lib/team-accordions'
import initStickyNav  from '/lib/sticky-nav'
import initHeroMatrix from './lib/careers'
import initServicesTabs from './lib/services-tabs'
import initPreheader from './lib/preheader'
import initCaseStudyGallery from './lib/case-study-gallery'
import initAiVideo from './lib/ai-video'
import initAiLogos from './lib/ai-logos'


initGreenSock()
initHeadroom()
initMobileNav()
initCookies()
initScrollTo()
initSlick()
initLibrary()
initTeamAccordions()
initStickyNav()
initHeroMatrix()
initMagnificPopup()
initServicesTabs()
initPreheader()
initCaseStudyGallery()
initAiVideo()
initAiLogos()
